import React from "react";
import { NavLink } from "react-router-dom";
import { ProfileHead } from "../ProfileHead";

const Wishlist = () => {
  const activeItem = "wishlist";
  const menuList = [
    { id: 1, title: "wishlist" },
    // {
    //   id: 2,
    //   title: "cancelled orders",
    //   orders: cancelledOrders,
    // },
  ];
  return (
    <div>
      <ProfileHead activeItem={"wishlist"} />

      <div className="mx-auto max-w-7xl px-2 lg:px-0 capitalize">
        {/* menus related section */}
        <div className="text-md font-medium text-center text-gray-600 border-b border-gray-200 dark:border-gray-700">
          <ul className="flex flex-wrap -mb-px capitalize">
            {menuList.map((menu) => (
              <li className="me-2" key={menu.id}>
                <NavLink
                  // onClick={() => handleChange(menu)}
                  className={`inline-block p-2 border-b-2 border-transparent rounded-t-lg 
                  ${
                    activeItem === menu.title
                      ? "border-blue-600 dark:text-blue-500 dark:border-blue-500"
                      : "hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                  }`}
                >
                  {menu.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        {/* right content */}
        <div>
          {/* {tabContent ? (
              tabContent.map((orderItem) => (
                <OrderLayout
                  key={orderItem._id}
                  orderDetail={orderItem && orderItem}
                />
              ))
            ) : (
              <div>
                <Skeleton />
                <Skeleton animation="wave" />
                <Skeleton animation={false} />
              </div>
            )} */}
        </div>
      </div>
    </div>
  );
};

export default Wishlist;
